import React, { createContext, ReactNode, useContext } from 'react';
import { TenantEnv } from 'types';
import { ServiceContainer } from 'helpers/service-provider';

interface ServiceProviderProps {
  children: ReactNode;
  services: ServiceContainer;
}

const ServiceContext = createContext<ServiceContainer | null>(null);

let serviceContainer: ServiceContainer | null = null;

// initialize services here
export const initializeServices = (
  tenantConfig: TenantEnv,
): ServiceContainer => {
  if (!serviceContainer) {
    serviceContainer = new ServiceContainer(tenantConfig);
  }
  return serviceContainer;
};

export const ServiceProvider: React.FC<ServiceProviderProps> = ({
  children,
  services,
}: ServiceProviderProps) => {
  return (
    <ServiceContext.Provider value={services}>
      {children}
    </ServiceContext.Provider>
  );
};

export const useServices = (): ServiceContainer => {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error(
      'useServices must be inside a ServiceProvider with a state value',
    );
  }
  return context;
};
